function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProducts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M21.794 5.392A1.003 1.003 0 0122 6v14a3 3 0 01-3 3H5a3 3 0 01-3-3V6a1 1 0 01.206-.608L5.2 1.4A1 1 0 016 1h12a1 1 0 01.8.4l2.994 3.992zM19 5l-1.5-2h-11L5 5h14zm1 2H4v13a1 1 0 001 1h14a1 1 0 001-1V7zm-5 3a1 1 0 012 0 5 5 0 01-10 0 1 1 0 112 0 3 3 0 006 0z"
  }));
}
export default SvgIconProducts;